/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthChallengeRequest as ModelsAuthenticationAuthChallengeRequest } from '../../models/Models/Authentication/auth-challenge-request';
import { AuthChallengeResponse as ModelsAuthenticationAuthChallengeResponse } from '../../models/Models/Authentication/auth-challenge-response';

export interface V4TokenAuthorizePost$Json$Json$Params {
      body?: ModelsAuthenticationAuthChallengeRequest
}

export function v4TokenAuthorizePost$Json$Json(http: HttpClient, rootUrl: string, params?: V4TokenAuthorizePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
  const rb = new RequestBuilder(rootUrl, v4TokenAuthorizePost$Json$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>;
    })
  );
}

v4TokenAuthorizePost$Json$Json.PATH = '/v4/token/authorize';
